import { render, staticRenderFns } from "./addressDetail.vue?vue&type=template&id=db252050&scoped=true&"
import script from "./addressDetail.vue?vue&type=script&lang=js&"
export * from "./addressDetail.vue?vue&type=script&lang=js&"
import style0 from "./addressDetail.vue?vue&type=style&index=0&id=db252050&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db252050",
  null
  
)

export default component.exports